import { render, staticRenderFns } from "./studySituation.vue?vue&type=template&id=2ce601a2"
import script from "./studySituation.vue?vue&type=script&lang=js"
export * from "./studySituation.vue?vue&type=script&lang=js"
import style0 from "./studySituation.vue?vue&type=style&index=0&id=2ce601a2&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports